module.exports = __webpack_public_path__ + "assets/img/2.aac1bb32.png";